// frontend/src/components/shop/ProductDescriptionModal.js
import React, { useState } from 'react';
import { X, HelpCircle, ShoppingCart } from 'lucide-react';

const ProductDescriptionModal = ({ product, onClose, onAddToCart }) => {
  const [quantity, setQuantity] = useState(1);

  if (!product) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 p-6 flex items-center justify-between z-10">
          <h2 className="text-2xl font-bold text-gray-900">
            {product.name}
          </h2>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Modal Content */}
        <div className="p-6">
          <div className="mb-4">
            <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
              <HelpCircle className="w-5 h-5 text-[#4897d2]" />
              Для чего это?
            </h3>
            <div className="prose prose-sm max-w-none">
              <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                {product.description}
              </p>
            </div>
          </div>

          {/* Product Info */}
          <div className="mt-6 pt-6 border-t border-gray-200 space-y-3">
            {product.category && (
              <div className="flex justify-between">
                <span className="text-gray-600">Категория:</span>
                <span className="font-semibold text-gray-900">{product.category.name}</span>
              </div>
            )}
            {product.pack_quantity && (
              <div className="flex justify-between">
                <span className="text-gray-600">В упаковке:</span>
                <span className="font-semibold text-gray-900">{product.pack_quantity} шт.</span>
              </div>
            )}
            <div className="flex justify-between">
              <span className="text-gray-600">Цена:</span>
              <span className="font-bold text-[#4897d2] text-xl">{product.price}₪</span>
            </div>
          </div>

          {/* Add to Cart in Modal */}
          <div className="mt-6 pt-6 border-t border-gray-200">
            <div className="flex items-center gap-3">
              <div className="flex items-center border-2 border-gray-200 rounded-lg overflow-hidden">
                <button
                  onClick={() => setQuantity(Math.max(1, quantity - 1))}
                  className="px-3 py-2 text-gray-600 hover:bg-gray-50 transition-colors"
                  disabled={quantity <= 1}
                >
                  −
                </button>
                <input
                  type="number"
                  min="1"
                  value={quantity}
                  onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value) || 1))}
                  className="w-12 text-center border-0 focus:ring-0 p-0 font-semibold"
                />
                <button
                  onClick={() => setQuantity(quantity + 1)}
                  className="px-3 py-2 text-gray-600 hover:bg-gray-50 transition-colors"
                >
                  +
                </button>
              </div>
              <button
                onClick={() => {
                  onAddToCart(product.id, quantity);
                  onClose();
                }}
                disabled={!product.is_available}
                className="flex-1 bg-gradient-to-r from-[#662d91] via-[#4897d2] to-[#28c4f4] text-white px-4 py-2 rounded-lg font-semibold hover:opacity-90 transition-opacity flex items-center justify-center gap-2 disabled:opacity-50"
              >
                <ShoppingCart className="w-5 h-5" />
                <span>В корзину</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDescriptionModal;

